var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluencersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.267,
    height: 15.312,
    viewBox: "0 0 16.267 15.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14410",
    "data-name": "Group 14410",
    transform: "translate(-419.237 -404.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14397",
    "data-name": "Group 14397"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_717",
    "data-name": "Line 717",
    x2: 16.267,
    transform: "translate(419.237 405.417)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_718",
    "data-name": "Line 718",
    x2: 10.521,
    transform: "translate(424.722 412.061)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_719",
    "data-name": "Line 719",
    x2: 10.521,
    transform: "translate(424.722 418.703)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5351",
    "data-name": "Rectangle 5351",
    width: 3.051,
    height: 3.051,
    transform: "translate(419.237 410.534)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5352",
    "data-name": "Rectangle 5352",
    width: 3.051,
    height: 3.051,
    transform: "translate(419.237 417.177)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencersIcon);
export default __webpack_public_path__ + "static/media/influencersIcon.5788e377a2240667e760bf2b1c89d2a0.svg";
export { ForwardRef as ReactComponent };